export enum SettingsTab {
  ACCOUNT = 'account',
  PEOPLE = 'people',
  ORGANIZATION = 'organization',
  HIRING = 'hiring',
  INTEGRATIONS = 'integrations',
}
